import { jwtDecode } from 'jwt-decode';

/**
 * Utility functions for working with JWT tokens
 */

/**
 * Decodes a JWT token and returns the payload
 * Note: This does NOT validate the signature - validation should be done server-side
 * @param token - The JWT token to decode
 * @returns The decoded payload or null if invalid
 */
export function decodeJwtToken(token: string): any {
    if (!token) {
        return null;
    }

    try {
        return jwtDecode(token);
    } catch (error) {
        console.error('Error decoding JWT token:', error);
        return null;
    }
}

/**
 * Extracts a specific claim from a JWT token
 * @param token - The JWT token
 * @param claimName - The name of the claim to extract
 * @returns The claim value or null if not found
 */
export function getJwtClaim(token: string, claimName: string): any {
    const payload = decodeJwtToken(token);
    return payload ? payload[claimName] : null;
}

/**
 * Checks if a JWT token is expired
 * @param token - The JWT token
 * @returns true if expired, false otherwise
 */
export function isJwtTokenExpired(token: string): boolean {
    const payload = decodeJwtToken(token);
    
    if (!payload || !payload.exp) {
        return true;
    }

    // exp is in seconds, Date.now() is in milliseconds
    const expirationDate = new Date(payload.exp * 1000);
    return expirationDate < new Date();
}

